import { Info } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// A short explainer, shown on the Panchang, Premium Panchangam and Festival
// Calendar, clarifying why observances are listed against the civil (English)
// date even though a tithi can span more or less than one calendar day.
// `dark` switches to the premium app's dark-glass styling.
export function CivilTithiNote({ dark = false, className = "" }) {
  const { pick } = useLang();
  const en = "Dates follow the civil (English) calendar for easy planning. A tithi — the lunar day that actually governs a festival or vrata — can begin or end partway through a day, so it sometimes spans two civil dates or fits within one. When an observance seems to shift, follow the tithi shown beside each date.";
  const hi = "सुगम नियोजन हेतु तिथियाँ अंग्रेज़ी (सिविल) कैलेंडर के अनुसार दर्शाई गई हैं। तिथि — जो वास्तव में किसी पर्व या व्रत का निर्धारण करती है — दिन के मध्य में आरम्भ या समाप्त हो सकती है; अतः यह कभी-कभी दो सिविल तिथियों में फैलती है या एक ही में समाहित रहती है। पर्व के खिसकने पर प्रत्येक तिथि के साथ दर्शाई गई तिथि का अनुसरण करें।";
  if (dark) {
    return (
      <div data-testid="civil-tithi-note" className={`flex items-start gap-2.5 rounded-2xl border border-white/[0.08] bg-white/[0.03] p-3.5 ${className}`}>
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-amber-300/80" />
        <p className="text-[13px] leading-relaxed text-white/60">{pick(hi, en)}</p>
      </div>
    );
  }
  return (
    <div data-testid="civil-tithi-note" className={`flex items-start gap-2.5 rounded-lg border border-line bg-[var(--parchment)]/40 p-3.5 ${className}`}>
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-saffron" />
      <p className="text-[13px] leading-relaxed text-ink-3">{pick(hi, en)}</p>
    </div>
  );
}

export default CivilTithiNote;
